export default {
    AccountSecurityPolicy: {
      top: {
        security: '密码安全策略',
        Default: '新用户默认密码',
        DefaultRules: '请输入新用户默认密码',
        Minlength: '最小密码长度',
        MinlengthRules: '请输入最小密码长度',
        Maxlength: '最长密码长度',
        MaxlengthRules: '请输入最长密码长度',
        lowercase: '最少小写字母数',
        lowercaseRules: '请输入最少小写字母数',
        uppercase: '最少大写字母数',
        uppercaseRules: '请输入最少大写字母数',
        special: '最少特殊字符数',
        specialRules: '请输入最少特殊字符数',
        oldpassword: '修改密码允许与旧密码相同',
        loginname: '密码允许与登录名相同',
      },
      bottom: {
        security: '登陆安全策略',
        Maxerrors: '最大密码错误次数',
        MaxerrorsRules: '请输入最大密码错误次数',
        Maxrecent: '最大近期密码数',
        errorscode: '密码错误次数启用验证码',
        verification: '启用图形验证码',
        locked: '允许锁定用户',
        duration: '锁定时长（秒）',
        durationRules: '请输入锁定时长（秒）',
        PC: 'PC端允许多地登录',
        Mobile: '移动端允许多地登录',
        initial: '强制修改初始密码',
        after: '修改密码后重新登录',
        secondary: '登录二次校验',
      }
    },
};
